/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Box } from "@mui/material";
import { acronymResolver } from "../../utils/acronymResolver";

export const SOURCE_OF_TRUTH_LABELS = {
  toast: "Toast",
  manual: "Manual",
  seven_shifts: "Seven Shifts",
};

export const RenderJobList = React.memo(({ data }) => {
  return (
    <Box>
      <ul style={{ padding: 0 }}>
        {data?.map((job, index) => {
          const acronym = acronymResolver(job?.source_of_truth);
          return (
            <li key={index} style={{ listStyle: "none" }}>
              <span>
                {job?.title}{" "}
                {acronym && (
                  <sup aria-label={`source: ${SOURCE_OF_TRUTH_LABELS[job?.source_of_truth] || job?.source_of_truth}`}>
                    {acronym}
                  </sup>
                )}
              </span>
            </li>
          );
        })}
      </ul>
    </Box>
  );
});

RenderJobList.displayName = 'RenderJobList'
